import React from 'react';
import { AuthCheckAdmin } from '../../../../Utils/AuthCheck/AdminCheck.auth';
import CoursesDataProvider from '../../../../Utils/Courses/CoursesDataProvider';
import UserDataAdminProvider from '../../../../Utils/Users/UserDataAdminProvider';
import UserCoursesInner from './UserCoursesInner.component';
import { useParams } from 'react-router-dom';

const UserCourses = () => {
  const { id } = useParams();
  return (
    <AuthCheckAdmin>
      <UserDataAdminProvider userId={id}>
        {(user) => (
          <CoursesDataProvider>
            {(courses) => <UserCoursesInner user={user} courses={courses} />}
          </CoursesDataProvider>
        )}
      </UserDataAdminProvider>
    </AuthCheckAdmin>
  );
};

export default UserCourses;
